var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10919 15.311C3.90248 15.5177 3.56241 15.5177 3.3557 15.311L0.155032 12.1103C-0.0516774 11.9036 -0.0516774 11.5635 0.155032 11.3568C0.361742 11.1501 0.701813 11.1501 0.908523 11.3568L3.199 13.6473V1.06469C3.199 0.7713 3.43905 0.53125 3.73244 0.53125C4.02584 0.53125 4.26589 0.7713 4.26589 1.06469V13.6473L6.55637 11.3568C6.76308 11.1501 7.10315 11.1501 7.30986 11.3568C7.51657 11.5635 7.51657 11.9036 7.30986 12.1103L4.10919 15.311ZM15.845 3.88862C16.0517 4.09533 16.0517 4.4354 15.845 4.64211C15.6383 4.84882 15.2982 4.84882 15.0915 4.64211L12.801 2.35163V14.9343C12.801 15.2276 12.561 15.4677 12.2676 15.4677C11.9742 15.4677 11.7341 15.2276 11.7341 14.9343V2.35163L9.44363 4.64211C9.23692 4.84882 8.89685 4.84882 8.69014 4.64211C8.48343 4.4354 8.48343 4.09533 8.69014 3.88862L11.8908 0.687949C12.0975 0.48124 12.4376 0.48124 12.6443 0.687949L15.845 3.88862Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.9553caa0b57e6602fdcd90cc4ddbfc22.svg";
export { ForwardRef as ReactComponent };